module.exports = __webpack_public_path__ + "img/Empty_Img.64aaeb8f.png";